import React, { useState } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "react-hot-toast";
import { useAuth } from "../context/AuthContext";
import { FiMail, FiLock, FiEye, FiEyeOff } from "react-icons/fi";

const Login = () => {

  const navigate = useNavigate();
  const { login } = useAuth();

  const [form, setForm] = useState({
    email: "",
    password: ""
  });

  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {

    e.preventDefault();

    if (!form.email || !form.password)
      return toast.error("Fill all fields");

    try {

      setLoading(true);

      const res = await axios.post("/api/auth/login", form);

      login(res.data.user);

      toast.success("Welcome Back 👑");

      navigate("/");

    } catch (err) {

      toast.error(err.response?.data?.message || "Login failed");

    } finally {

      setLoading(false);

    }

  };

  return (

    <div className="min-h-screen flex items-center justify-center bg-black relative overflow-hidden">

      <div className="absolute w-[500px] h-[500px] bg-yellow-500/20 blur-[160px] rounded-full top-[-100px] left-[-100px]"></div>
      <div className="absolute w-[500px] h-[500px] bg-purple-500/20 blur-[160px] rounded-full bottom-[-100px] right-[-100px]"></div>

      <motion.div
        initial={{ opacity:0, y:60 }}
        animate={{ opacity:1, y:0 }}
        className="backdrop-blur-xl bg-white/10 border border-white/20 p-10 rounded-3xl w-full max-w-md text-white shadow-2xl"
      >

        <h2 className="text-4xl font-bold text-center mb-2">
          MS Bridal
        </h2>

        <p className="text-center text-gray-400 mb-8">
          Luxury Fashion Experience
        </p>

        <form onSubmit={handleSubmit} className="space-y-6">

          <div className="relative">

            <FiMail className="absolute left-4 top-4 text-gray-400"/>

            <input
              type="email"
              name="email"
              placeholder="Email"
              value={form.email}
              onChange={handleChange}
              className="w-full pl-12 py-3 bg-white/10 border border-white/20 rounded-lg focus:ring-2 focus:ring-yellow-500 outline-none"
            />

          </div>

          <div className="relative">

            <FiLock className="absolute left-4 top-4 text-gray-400"/>

            <input
              type={showPassword ? "text" : "password"}
              name="password"
              placeholder="Password"
              value={form.password}
              onChange={handleChange}
              className="w-full pl-12 pr-12 py-3 bg-white/10 border border-white/20 rounded-lg focus:ring-2 focus:ring-yellow-500 outline-none"
            />

            <button
              type="button"
              onClick={()=>setShowPassword(!showPassword)}
              className="absolute right-4 top-3"
            >
              {showPassword ? <FiEyeOff/> : <FiEye/>}
            </button>

          </div>

          <motion.button
            whileTap={{ scale:0.96 }}
            whileHover={{ scale:1.02 }}
            disabled={loading}
            className="w-full bg-gradient-to-r from-yellow-400 to-yellow-600 text-black font-semibold py-3 rounded-lg"
          >
            {loading ? "Logging in..." : "Login"}
          </motion.button>

        </form>

        <p className="text-center mt-6 text-gray-400">

          Don't have an account?{" "}

          <Link
            to="/signup"
            className="text-yellow-400 hover:text-yellow-300"
          >
            Create account
          </Link>

        </p>

      </motion.div>

    </div>

  );

};

export default Login;